// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".locations[data-v-34d1a616]{font-size:var(--body);height:45vh;overflow-x:hidden;overflow-y:auto;position:relative}.locations[data-v-34d1a616] ul ul li .node{border-color:#c0cadd}.locations[data-v-34d1a616] ul ul .node .hierarchy-link{padding-left:1.5em}.locations[data-v-34d1a616] ul ul ul .node .hierarchy-link{padding-left:2.25em}.locations[data-v-34d1a616] ul ul{background-color:#e1e6ef}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
